export default "__VITE_ASSET__1d154dd2__"